import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "stores/store"
import { markStates } from "utils/misc"

import { SearchFlowState, ToastData, UIInitialState } from "./types"

const initialState: UIInitialState = {
  hoveredPropertyId: null,
  currentSearchTab: null,
  headerAlert: {
    headerAlertShow: false,
    headerAlertMessage: "",
  },
  openedPropertyCardInMapBox: null,
  toastData: null,
}

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    resetUIStore: (state) => {
      markStates(initialState, state)
    },
    markUI: (state, action: PayloadAction<Partial<UIInitialState>>) => {
      markStates(action.payload, state)
    },
    markSearchFlow: (state, action: PayloadAction<SearchFlowState>) => {
      state.currentSearchTab = action.payload.currentSearchTab
    },
    setCustomToast: (state, action: PayloadAction<ToastData | null>) => {
      state.toastData = action.payload
    },
  },
})

export const { markUI, resetUIStore, markSearchFlow, setCustomToast } =
  uiSlice.actions

export const selectHoveredPropertyId = (state: RootState) =>
  state.uiReducer.hoveredPropertyId

export const selectOpenedPropertyCardInMapBox = (state: RootState) =>
  state.uiReducer.openedPropertyCardInMapBox

export const selectUI = (state: RootState) => state.uiReducer

export const selectHeaderAlert = (state: RootState) =>
  state.uiReducer.headerAlert

export default uiSlice.reducer
